import { selectAllBrand, insertBrand, updateBrand, deleteBrand, selectAllBrandType, insertBrandType, updateBrandType, deleteBrandType } from "../../api/config/modules/dictionaryManagement";

const state = {
    selectAllBrand: {},
    insertBrand: {},
    updateBrand: {},
    deleteBrand: {},
    selectAllBrandType: {},
    insertBrandType: {},
    updateBrandType: {},
    deleteBrandType: {},
};

const mutations = {
    SET_SELECTALLBRAND: (state, selectAllBrand) => {
        state.selectAllBrand = selectAllBrand;
    },
    SET_INSERTBRAND: (state, insertBrand) => {
        state.insertBrand = insertBrand;
    },
    SET_UPDATEBRAND: (state, updateBrand) => {
        state.updateBrand = updateBrand;
    },
    SET_DELETEBRAND: (state, deleteBrand) => {
        state.deleteBrand = deleteBrand;
    },
    SET_SELECTALLTYPE: (state, selectAllBrandType) => {
        state.selectAllBrandType = selectAllBrandType;
    },
    SET_INSERTBRANDTYPE: (state, insertBrandType) => {
        state.insertBrandType = insertBrandType;
    },
    SET_UPDATEBRANDTYPE: (state, updateBrandType) => {
        state.updateBrandType = updateBrandType;
    },
    SET_DELETEBRANDTYPE: (state, deleteBrandType) => {
        state.deleteBrandType = deleteBrandType;
    },
};

const actions = {
    GET_SELECTALLBRAND: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectAllBrand(data)
                .then((res) => {
                    commit("SET_SELECTALLBRAND", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTBRAND: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertBrand(data)
                .then((res) => {
                    commit("SET_INSERTBRAND", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEBRAND: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateBrand(data)
                .then((res) => {
                    commit("SET_UPDATEBRAND", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEBRAND: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteBrand(data)
                .then((res) => {
                    commit("SET_DELETEBRAND", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_SELECTALLTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            selectAllBrandType(data)
                .then((res) => {
                    commit("SET_SELECTALLTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_INSERTBRANDTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            insertBrandType(data)
                .then((res) => {
                    commit("SET_INSERTBRANDTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_UPDATEBRANDTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            updateBrandType(data)
                .then((res) => {
                    commit("SET_UPDATEBRANDTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    GET_DELETEBRANDTYPE: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
            deleteBrandType(data)
                .then((res) => {
                    commit("SET_DELETEBRANDTYPE", res);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
